import theme from '../../theme';
function QuizScore({ score, total, onRestart }) {
  const percentage = Math.round((score / total) * 100);

  return (
    <div style={{ textAlign: 'center', padding: '1rem', color: theme.textPrimary }}>
      <h3 style={{ fontSize: '22px', color: theme.gold, marginBottom: '0.5rem', fontFamily: "'EB Garamond', Georgia, serif" }}>
        Quiz Complete
      </h3>

      <div style={{
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        border: `3px solid ${theme.gold}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '1rem auto',
      }}>
        <span style={{ fontSize: '32px', fontWeight: '600', color: theme.gold }}>{score}</span>
        <span style={{ fontSize: '12px', color: theme.textMuted }}>/{total}</span>
      </div>

      <p style={{ fontSize: '14px', color: theme.textPrimary, margin: '0.25rem 0' }}>
        {percentage}%
      </p>
      <p style={{ fontSize: '12px', color: theme.textMuted, margin: '0.25rem 0 1.5rem' }}>
        {percentage >= 80
          ? 'Excellent. Strong grasp of Austrian Economics.'
          : percentage >= 50
          ? 'Good effort. Keep exploring the concepts.'
          : 'Keep studying. Austrian Economics rewards patience.'}
      </p>

      <button
        onClick={onRestart}
        className="btn-primary"
      >
        Try Again
      </button>
    </div>
  );
}

export default QuizScore;
